var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.999,
    height: 28,
    viewBox: "0 0 31.999 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M10-2H6A2,2,0,0,1,4-4V-20a2,2,0,0,1,2-2h4a2,2,0,0,0,2-2,2,2,0,0,0-2-2H6a6,6,0,0,0-6,6V-4A6,6,0,0,0,6,2h4a2,2,0,0,0,2-2A2,2,0,0,0,10-2ZM31.413-13.413l-8-8a2,2,0,0,0-2.828,0,2,2,0,0,0,0,2.828L25.175-14H12a2,2,0,0,0-2,2,2,2,0,0,0,2,2H25.175L20.589-5.414a2,2,0,0,0,0,2.828,2,2,0,0,0,2.828,0l8-8A2,2,0,0,0,31.413-13.413Z",
    transform: "translate(0 26)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.ab2e49b670950a3615881818d61d8ea1.svg";
export { ForwardRef as ReactComponent };